const secondsToTimeFormat = (currentSeconds) => {
  const seconds = `0${currentSeconds % 60}`.slice(-2)
  const minutes = `0${Math.floor(currentSeconds / 60) % 60}`.slice(-2)
  const hours = `0${Math.floor(currentSeconds / 3600)}`.slice(-2)

  return `${hours}:${minutes}:${seconds}`
}

export default secondsToTimeFormat
